import React, { Component } from "react";
import { currentLocals } from "../../languages/languages.js";
import "../../styles/Header.css";
import "../../styles/MessageNoAccess.css";

//export default class Header extends Component
class MessageNoAccess extends Component {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    //e.preventDefault();
    window.document.getElementById("btLogout").click();
    //logout({}); onClick={handleClick}
  }

  render() {
    const displaystyle = this.props.noaccess ? "block" : "none";
    return (
      <div id="myModal" className="mi-modal" style={{ display: displaystyle }}>
        <div className="mi-modal-content">
          <div className="mi-modal-header">
            {/*
            <h2>{currentLocals(this.props.locale).general.Not_permission}</h2>
            <span className="close" onClick={this.handleClick}>
              &times;
              </span>*/}
          </div>
          <div className="mi-modal-body" id={this.props.requiredpermissions}>
            {/*<p>{currentLocals(this.props.locale).general.Required_Permissions}</p>
            <p>{this.props.requiredpermissions.toString()}</p>
            <p>{currentLocals(this.props.locale).general.Current_Permissions}</p>
            <p>{this.props.currentpermissions.toString()}</p>*/}
          </div>
          <div className="mi-modal-footer">
            <p>
              <h3>{currentLocals(this.props.locale).general.NotHavePermissions}</h3>
            </p>
            <p>{currentLocals(this.props.locale).general.ContactUserManager}</p>
            {/*<p>{currentLocals(this.props.locale).general.BackToMyLectra}</p>*/}
          </div>
        </div>
      </div>
    );
  }
}
export default MessageNoAccess;
